import {
  VALIDATE_FLIGHT_DETAILS,
  VALIDATE_FLIGHT_DETAILS_SUCCESS,
  VALIDATE_FLIGHT_DETAILS_ERROR,
  VALIDATE_FLIGHT_DETAILS_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetValidateFlightDetails = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_FLIGHT_DETAILS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VALIDATE_FLIGHT_DETAILS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case VALIDATE_FLIGHT_DETAILS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VALIDATE_FLIGHT_DETAILS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetValidateFlightDetails;
